import React, { useState, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Card,
  CardContent,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { makeStyles } from '@material-ui/core/styles';
import "./App.css";
import InfoBox from "./InfoBox";
import Map from "./Map";
import Table from "./Table";
import { sortData, prettyPrintStat } from "./util";
import TextField from "@material-ui/core/TextField";
//import numeral from "numeral";

import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";

function App() {
  //STATE= how to write the variable in REACT we dont use global

  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(["worldwide"]);
  const [countryInfo, setCountryInfo] = useState({});
  const [TableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  const useStyles = makeStyles({
    option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
  });
  const classes = useStyles();

  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((response) => response.json())
      .then((data) => {
        setCountryInfo(data);
      });
  }, []);
  //useeffect=runs a piece of code that is based on condition
  //map is loop ; dffernece foreach is map return array
  useEffect(() => {
    //this is the react hoooks
    //The code inside here will run once
    //when the componenet loads and not again
    //async->send a request,wait for it,do something with input
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        .then((response) => response.json())
        .then((data) => {
          const countries = data.map((country) => ({
            name: country.country,
            value: country.countryInfo.iso2, //uK,USA
            flag:country.countryInfo.flag
          }));
          countries.push({
            name: "worldwide",
            value: "worldwide",
            flag:
              "https://cdn2.iconfinder.com/data/icons/pittogrammi/142/39-512.png",
          });
          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        });
    };
    getCountriesData();
  }, []);

  const onCountryChange = async (e, country) => {
    if(country === null) return ;
    const countryCode = country.value;
    // console.log('yooooo>>>>>>',countryCode)
    // setCountry(countryCode);
    const url =
      countryCode === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCountry(countryCode);
        setCountryInfo(data);
        if (countryCode !== "worldwide") {
          setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
          setMapZoom(3);
        } else {
          setMapZoom(2);
        }
      });
  };

  // console.log("country info >>>>>", countryInfo);

  return (
    <div className="app">
      <div className="app_left">
        <div className="app_header">
          <h1>COVID-19 TRACKER</h1>
          {/* loop through country and show  a dropdon */}
          
            {/* <Select
              variant="outlined"
              onChange={onCountryChange}
              value={country}
            >
              
              <MenuItem value="worldwide">World Wide</MenuItem>
              {countries.map((country) => (
                <MenuItem value={country.value}>{country.name}</MenuItem>
              ))}
            </Select> */}
            <Autocomplete
           
              id="country-select-demo"
              style={{ width: 300 }}
              options={countries}
              classes={{
                option: classes.option,
              }}
              autoHighlight
              onChange={onCountryChange}
              getOptionLabel={(option) => option.name}
              renderOption={(option) => (
                <React.Fragment>
                  <span>
                    <img src={option.flag} alt="" width="20" height="20"/>
                    </span>
                    {option.name}

                 
                </React.Fragment>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose a country"
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password", // disable autocomplete and autofill
                  }}
                />
              )}
            />
         
        </div>
        <div className="app_stats">
          <InfoBox
            isRed
            active={casesType === "cases"}
            onClick={(e) => setCasesType("cases")}
            title="CoronoVirus Cases"
            cases={prettyPrintStat(countryInfo.todayCases)}
            total={prettyPrintStat(countryInfo.cases)}
          />
          <InfoBox
            active={casesType === "recovered"}
            onClick={(e) => setCasesType("recovered")}
            title="Recovered"
            cases={prettyPrintStat(countryInfo.todayRecovered)}
            total={prettyPrintStat(countryInfo.recovered)}
          />
          <InfoBox
            isRed
            active={casesType === "deaths"}
            onClick={(e) => setCasesType("deaths")}
            title="Deaths"
            cases={prettyPrintStat(countryInfo.todayDeaths)}
            total={prettyPrintStat(countryInfo.deaths)}
          />
        </div>
        <Map
          casesType={casesType}
          countries={mapCountries}
          center={mapCenter}
          zoom={mapZoom}
        />
      </div>
      {/* <Card className="app_right">
        <CardContent>
          <h3 className="app_graphTitle"> WorldWide new {casesType}</h3>
          <LineGraph className="app_graph" casesType={casesType} />
          <h3>Live Cases By Country</h3>
          <Table countries={TableData} />
        </CardContent>
      </Card> */}
    </div>
  );
}

export default App;
